// import React, { useState } from "react";

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing161({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/161/01.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/161/02.gif`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      eventDates={true}
    />
  );
}

export default Randing161;
